(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["seen-on"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seen-on-strip')) {
    customElements.define('seen-on-strip', class extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.videos.forEach((v) => {
          v.muted = true; v.defaultMuted = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
              else v.pause();
            });
          }, { threshold: 0.25 });
          this.videos.forEach((v) => this.io.observe(v));
        } else {
          this.videos.forEach((v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); });
        }
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
